export enum CuffaGenderEnum {
  MASCULINO = 'MASCULINO',
  FEMININO = 'FEMININO',
  PREFIRO_NAO_RESPONDER = 'PREFIRO NÃO RESPONDER',
}

export enum CuffaMaritalStatusEnum {
  SOLTEIRO = 'SOLTEIRO',
  CASADO = 'CASADO',
  UNIAO_ESTAVEL = 'UNIÃO ESTÁVEL',
  VIUVO = 'VIUVO',
  SEPARADO_DIVORCIADO = 'SEPARADO/DIVORCIADO',
}

export enum CuffaCollectionStatusEnum {
  EM_COLETA_RASCUNHO = 'EM COLETA (RASCUNHO)',
  EM_COLETA_INCOMPLETO = 'EM COLETA (INCOMPLETO)',
  SINCRONIZADO = 'SINCRONIZADO',
  VALIDADO_PELO_MUNICIPIO = 'VALIDADO PELO MUNICÍPIO',
  ENVIADO_AO_ESTADO = 'ENVIADO AO ESTADO',
  DEVOLVIDO_PELO_ESTADO = 'DEVOLVIDO PELO ESTADO',
  PROCESSO_FINALIZADO = 'PROCESSO FINALIZADO',
}

// US03 - Categoria Fundiária
export enum CuffaLandCategoryEnum {
  PROPRIEDADE_RURAL_PARTICULAR = 'PROPRIEDADE RURAL PARTICULAR',
  PROPRIEDADE_RURAL_ARRENDADA = 'PROPRIEDADE RURAL ARRENDADA',
  POSSE = 'POSSE',
  PRODUTOR_MEEIRO = 'PRODUTOR MEEIRO',
  AREA_DE_USO_COLETIVO_DA_TERRA = 'ÁREA DE USO COLETIVO DA TERRA',
  ASSENTAMENTO_FEDERAL_ESTADUAL = 'ASSENTAMENTO FEDERAL/ESTADUAL',
  PNCF_TERRA_BRASIL_BANCO_DA_TERRA = 'PNCF/TERRA BRASIL/BANCO DA TERRA',
  COMUNIDADE_QUILOMBOLA = 'COMUNIDADE QUILOMBOLA',
  COMUNIDADE_TRADICIONAL = 'COMUNIDADE TRADICIONAL',
  TERRA_INDIGENA = 'TERRA INDÍGENA',
}
export interface ICuffaUpdateLandCategoryDto {
  land_category: string;
  land_category_additional_info?: string;
}

// US03.1 - Cadastrar Produtos
export enum CuffaProductionTypeEnum {
  VEGETAL = 'VEGETAL',
  ANIMAL = 'ANIMAL',
}

export enum CuffaManagementTypeEnum {
  AGROECOLOGICA = 'AGROECOLÓGICA',
  SISTEMAS_AGROFLORESTAIS_SAF = 'SISTEMAS AGROFLORESTAIS (SAF)',
  ORGANICA = 'ORGÂNICA',
  CONVENCIONAL = 'CONVENCIONAL',
}

export enum CuffaMeasurementUnitEnum {
  QUILOGRAMAS = 'QUILOGRAMAS',
  TONELADAS = 'TONELADAS',
  LITROS = 'LITROS',
  UNIDADES = 'UNIDADES',
  CABECAS = 'CABEÇAS',
  MIL_FRUTOS = 'MIL FRUTOS',
  ARROBAS = 'ARROBAS',
  MACOS = 'MAÇOS',
  FARDOS = 'FARDOS',
  CAIXAS = 'CAIXAS',
  MIL_LITROS = 'MIL LITROS',
}

// US03.2 & US03.3 - Certificações
export enum CuffaAgroecologicalCertificationEnum {
  CERTIFICADORA_POR_AUDITORIA = 'CERTIFICADORA POR AUDITORIA',
  ORGANISMO_PARTICIPATIVO_OPAC = 'ORGANISMO PARTICIPATIVO DE AVALIAÇÃO DA CONFORMIDADE - OPAC',
  ORGANIZACAO_CONTROLE_SOCIAL_OCS = 'ORGANIZAÇÃO DE CONTROLE SOCIAL – OCS',
  OUTRO = 'OUTRO',
}

// US03.4 - Certificações da Família
export enum CuffaFamilyCertificationTypeEnum {
  CERTIFICACAO_POR_AUDITORIA_OCS = 'CERTIFICAÇÃO POR AUDITORIA (OCS)',
  SISTEMA_PARTICIPATIVO_GARANTIA_SPG = 'SISTEMA PARTICIPATIVO DE GARANTIA (SPG)',
  CONTROLE_SOCIAL_VENDA_DIRETA = 'CONTROLE SOCIAL EM VENDA DIRETA',
  OUTRO = 'OUTRO',
}

// US04.0 - Selos de Inspeção
export enum CuffaSanitaryAgencyEnum {
  SECRETARIA_SAUDE_MUNICIPIO = 'SECRETARIA DE SAÚDE DO MUNICÍPIO',
  SECRETARIA_SAUDE_ESTADO = 'SECRETARIA DE SAÚDE DO ESTADO',
}

export enum CuffaInspectionSealEnum {
  SERVICO_INSPECAO_MUNICIPAL_SIM = 'SERVIÇO DE INSPEÇÃO MUNICIPAL – SIM',
  SERVICO_INSPECAO_ESTADUAL_SISE = 'SERVIÇO DE INSPEÇÃO ESTADUAL – SISE',
  SERVICO_INSPECAO_FEDERAL_SIF = 'SERVIÇO DE INSPEÇÃO FEDERAL – SIF',
  SISTEMA_BRASILEIRO_INSPECAO_SISBI = 'SISTEMA BRASILEIRO DE INSPEÇÃO DE PRODUTOS DE ORIGEM ANIMAL – SISBI',
  SISTEMA_ESTADUAL_SUSAF_MT = 'SISTEMA ESTADUAL UNIFICADO DE SANIDADE AGROINDUSTRIAL FAMILIAR – SUSAF MT',
  SERVICO_INSPECAO_PEQUENO_PORTE_SIAPP = 'SERVIÇO DE INSPEÇÃO AGROINDUSTRIAL DE PEQUENO PORTE – SIAPP',
}

// US05 - Selos de Agregação de Valor
export enum CuffaValueAddedSealEnum {
  SELO_CERTIFICACAO_SOCIOAMBIENTAL = 'SELO DE CERTIFICAÇÃO SOCIOAMBIENTAL',
  SELO_COMERCIO_JUSTO_SOLIDARIO_FAIRTRADE = 'SELO DE COMÉRCIO JUSTO E SOLIDÁRIO (FAIRTRADE)',
  SELO_IDENTIFICACAO_ORIGEM = 'SELO DE IDENTIFICAÇÃO DE ORIGEM',
  SELO_INDICACAO_GEOGRAFICA = 'SELO DE INDICAÇÃO GEOGRÁFICA',
  SELO_PRODUTO_ARTESANAL = 'SELO DE PRODUTO ARTESANAL',
  SELO_RASTREABILIDADE = 'SELO DE RASTREABILIDADE',
  SELO_SENAF_AGRICULTURA_FAMILIAR = 'SELO NACIONAL DA AGRICULTURA FAMILIAR - SENAF/AGRICULTURA FAMILIAR',
  SELO_SENAF_JUVENTUDE = 'SELO NACIONAL DA AGRICULTURA FAMILIAR - SENAF/JUVENTUDE',
  SELO_SENAF_MULHER = 'SELO NACIONAL DA AGRICULTURA FAMILIAR - SENAF/MULHER',
  SELO_SENAF_QUILOMBOLA = 'SELO NACIONAL DA AGRICULTURA FAMILIAR - SENAF/QUILOMBOLA',
  SELO_SENAF_SOCIOBIODIVERSIDADE = 'SELO NACIONAL DA AGRICULTURA FAMILIAR - SENAF/SOCIOBIODIVERSIDADE',
  OUTRO = 'OUTRO',
}

// US06 - Canais de Comercialização
export enum CuffaCommercializationChannelEnum {
  COOPERATIVAS_AGRICULTURA_FAMILIAR = 'COOPERATIVAS DA AGRICULTURA FAMILIAR',
  AGROINDUSTRIAS_AGRICULTURA_FAMILIAR = 'AGROINDÚSTRIAS DA AGRICULTURA FAMILIAR',
  COOPERATIVAS_NAO_AGRICULTURA_FAMILIAR = 'COOPERATIVAS NÃO ENQUADRADAS COMO DE AGRICULTURA FAMILIAR',
  AGROINDUSTRIAS_NAO_AGRICULTURA_FAMILIAR = 'AGROINDÚSTRIAS OU INDÚSTRIAS NÃO ENQUADRADAS COMO DE AGRICULTURA FAMILIAR',
  BARES_RESTAURANTES_LANCHONETES_HOTEIS = 'BARES, RESTAURANTES, LANCHONETES E HOTÉIS',
  EXPORTACAO_EMPRESAS_EXPORTADORAS = 'EXPORTAÇÃO OU EMPRESAS EXPORTADORAS (COMERCIALIZAÇÃO PARA OUTROS PAÍSES)',
  FEIRAS = 'FEIRAS',
  MERCADOS_SUPERMERCADOS_OUTROS_ESTADOS = 'MERCADOS/ SUPERMERCADOS DE OUTROS ESTADOS',
  MERCADOS_SUPERMERCADOS_OUTROS_MUNICIPIOS_MT = 'MERCADOS/ SUPERMERCADOS DE OUTROS MUNICÍPIOS DE MATO GROSSO',
  MERCADOS_SUPERMERCADOS_QUITANDAS_MUNICIPIO = 'MERCADOS/ SUPERMERCADOS/QUITANDAS DO MUNICÍPIO',
  PROGRAMA_AQUISICAO_ALIMENTOS_PAA = 'PROGRAMA DE AQUISIÇÃO DE ALIMENTOS - PAA',
  PROGRAMA_NACIONAL_ALIMENTACAO_ESCOLAR_PNAE = 'PROGRAMA NACIONAL DE ALIMENTAÇÃO ESCOLAR - PNAE',
  REVENDEDORES_ATRAVESSADORES_INTERMEDIARIOS = 'REVENDEDORES/ ATRAVESSADORES/ INTERMEDIÁRIOS',
  VENDA_DIRETA_CONSUMIDOR_FINAL = 'VENDA DIRETA PARA O CONSUMIDOR FINAL',
  VENDAS_ORGAOS_PUBLICOS_COMPRAS_GOVERNAMENTAIS = 'VENDAS PARA ÓRGÃOS PÚBLICOS EM GERAL (COMPRAS GOVERNAMENTAIS)',
  OUTRO = 'OUTRO',
}

// US07 - Crédito e Fontes de Renda
export enum CuffaFinancialInstitutionEnum {
  BANCO_DA_AMAZONIA = 'BANCO DA AMAZÔNIA',
  BANCO_DO_BRASIL = 'BANCO DO BRASIL',
  BRADESCO = 'BRADESCO',
  CAIXA_ECONOMICA_FEDERAL = 'CAIXA ECONÔMICA FEDERAL',
  CRESOL = 'CRESOL',
  PRIMACREDI = 'PRIMACREDI',
  SEAF_ESTADUAL = 'SEAF - ESTADUAL',
  SICOOB = 'SICOOB',
  SICREDI = 'SICREDI',
}

export enum CuffaCreditLineEnum {
  RECURSO_PROPRIO_INSTITUICAO = 'RECURSO PRÓPRIO DA INSTITUIÇÃO',
  FUNDAAF = 'FUNDAAF',
}

export enum CuffaCreditTypeEnum {
  RECURSO_PROPRIO_INSTITUICAO = 'RECURSO PRÓPRIO DA INSTITUIÇÃO',
  INCENTIVO_PRODUTIVO_FUNDAAF = 'INCENTIVO PRODUTIVO – FUNDAAF',
  INCLUSAO_RURAL_FUNDAAF = 'INCLUSÃO RURAL – FUNDAAF',
}

// US08 - Fonte de Renda da Família
export enum CuffaIncomeSourceEnum {
  PRESTACAO_SERVICO_EXTERNO = 'PRESTAÇÃO DE SERVIÇO EXTERNO EM OUTRAS PROPRIEDADES LOCAIS',
  ASSALARIADO_ATIVIDADE_FORA_PROPRIEDADE = 'ASSALARIADO (ATIVIDADE EXERCIDA FORA DA PROPRIEDADE)',
  ATIVIDADE_PRODUTIVA_PROPRIEDADE = 'ATIVIDADE PRODUTIVA NA PROPRIEDADE',
  APOSENTADORIA = 'APOSENTADORIA',
  PENSAO = 'PENSÃO',
  RECURSOS_PROGRAMAS_SOCIAIS = 'RECURSOS DE PROGRAMAS SOCIAIS',
}

// US09 - Renda e Participação Feminina
export enum CuffaWomenDecisionParticipationEnum {
  SIM = 'SIM',
  NAO = 'NÃO',
  NAO_SE_APLICA = 'NÃO SE APLICA',
}

export enum CuffaWomenIncomeSourceEnum {
  NAO_SE_APLICA = 'NÃO SE APLICA',
  PRESTACAO_SERVICO_EXTERNO = 'PRESTAÇÃO DE SERVIÇO EXTERNO EM OUTRAS PROPRIEDADES LOCAIS',
  ASSALARIADO_ATIVIDADE_FORA_PROPRIEDADE = 'ASSALARIADO (ATIVIDADE EXERCIDA EM OUTRO ESTABELECIMENTO QUE NÃO O PRÓPRIO)',
  ATIVIDADE_PRODUTIVA_PROPRIEDADE = 'ATIVIDADE PRODUTIVA NA PROPRIEDADE',
  APOSENTADORIA = 'APOSENTADORIA',
  PENSAO = 'PENSÃO',
  RECURSOS_PROGRAMAS_SOCIAIS = 'RECURSOS DE PROGRAMAS SOCIAIS',
  OUTRO = 'OUTRO',
}

// US10 - Principais Dificuldades à Produção
export enum CuffaProductionDifficultyEnum {
  CONDICAO_DAS_ESTRADAS = 'CONDIÇÃO DAS ESTRADAS',
  NECESSIDADE_CONSTRUCAO_PONTES_OBRAS = 'NECESSIDADE DE CONSTRUÇÃO DE PONTES E OBRAS ESPECIAIS NAS ESTRADAS',
  DIFICULDADE_ACESSO_LOCALIDADES = 'DIFICULDADE DE ACESSO ÀS LOCALIDADES',
  DISTANCIA_CENTROS_CONSUMIDORES = 'DISTÂNCIA DOS CENTROS CONSUMIDORES',
  FALTA_MERCADO_CONSUMIDOR = 'FALTA DE MERCADO CONSUMIDOR / NÃO TER PARA QUEM VENDER TUDO QUE PRODUZ',
  DIFICULDADE_ACESSAR_CREDITO_RURAL = 'DIFICULDADE OU IMPEDIMENTO PARA ACESSAR CRÉDITO RURAL',
  CONDICOES_SAUDE_MEMBROS_FAMILIA = 'CONDIÇÕES DE SAÚDE DO(S) MEMBRO(S) DA FAMÍLIA QUE TRABALHAM NA ATIVIDADE',
  FALTA_VEICULOS_TRANSPORTAR_PRODUCAO = 'FALTA DE VEÍCULOS PARA TRANSPORTAR A PRODUÇÃO',
  FALTA_VEICULO_APROPRIADO_PERECIVEIS = 'FALTA DE VEÍCULO APROPRIADO PARA ALIMENTOS PERECÍVEIS',
  FALTA_MAO_OBRA = 'FALTA DE MÃO DE OBRA',
  CUSTO_PRODUCAO_ELEVADO = 'CUSTO DE PRODUÇÃO ELEVADO',
  FALTA_INFORMACAO = 'FALTA DE INFORMAÇÃO',
  REGULARIZACAO_AMBIENTAL = 'REGULARIZAÇÃO AMBIENTAL',
  REGULARIZACAO_FISCAL = 'REGULARIZAÇÃO FISCAL',
  REGULARIZACAO_FUNDIARIA = 'REGULARIZAÇÃO FUNDIÁRIA',
  REGULARIZACAO_SANITARIA = 'REGULARIZAÇÃO SANITÁRIA',
}

export const getCuffaGenderEnumValues = (): string[] => Object.values(CuffaGenderEnum);
export const getCuffaCollectionStatusValues = (): string[] => Object.values(CuffaCollectionStatusEnum);

export const createICuffaUpdateLandCategoryDto = (): ICuffaUpdateLandCategoryDto => ({
  land_category: 'PROPRIEDADE RURAL PARTICULAR',
});
